module.exports = require('./src/table');